module.exports = "<learnmore-display\n  [breadcrumbPre]=\"breadcrumbPre\"\n  [directoryPrefix]=\"getLearnmoreSection()\"\n></learnmore-display>"